import React, { useState, useEffect, useRef } from "react";
import { setTitle } from "../../helpers/MetaTag";
import Button from "../../components/form/Button";
import Select from "../../components/form/Select";
import Input from "../../components/form/Input";
import Textarea from "../../components/form/Textarea";
import { Link } from "react-router-dom";
import toastr from "toastr";
import { postData } from "../../services/api";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";

import { useTranslation } from "react-i18next";
import Image from "../../components/elements/Image";
import { MAIN_LOGO } from "../../constant/Constant";

const LeadTracking = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Sales team"
  );
  const { t } = useTranslation();
  const flatPicker = useRef(null);
  const [sizes, setSizes] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [companyAdministrator, setCompanyAdministrator] = useState("");
  const [companyAdministratorEmail, setCompanyAdministratorEmail] =
    useState("");
  const [verifyCompanyAdministratorEmail, setVerifyCompanyAdministratorEmail] =
    useState("");
  const [companyAdministratorPhone, setCompanyAdministratorPhone] =
    useState("");
  const [companyLocation, setCompanyLocation] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [leadSource, setLeadSourcee] = useState("");
  const [contactDate, setContactDate] = useState("");
  const [firstResponseDate, setFirstResponseDate] = useState("");
  const [responseType, setResponseType] = useState("");
  const [responder, setResponder] = useState("");
  const [firstResponseNotes, setFirstResponseNotes] = useState("");
  const [decision, setDecision] = useState("");
  const [demoDate, setDemoDate] = useState("");
  const [demoNotes, setDemoNotes] = useState("");
  const [demoCompletion, setDemoCompletion] = useState("");
  const [secondDemoDate, setSecondDemoDate] = useState("");
  const [secondDemoNotes, setSecondDemoNotes] = useState("");
  const [secondDemoCompletion, setSecondDemoCompletion] = useState("");
  const [status, setStatus] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isCancel, setIsCancel] = useState(false);

  const onCancel = async (e) => {
    setIsCancel(true);
    setIsCancel(false);
  };

  const onUpdate = async (e) => {
    setIsUpdate(true);
    try {
      const result = await postData("salesteam/lead-create", {
        company_name: companyName,
        primary_contact_name: companyAdministrator,
        primary_contact_email: companyAdministratorEmail,
        verify_company_adminstrator_email: verifyCompanyAdministratorEmail,
        company_location: companyLocation,
        primary_contact_phone: companyAdministratorPhone,
        company_size: companySize,
        referred_by: referredBy,
        lead_source: leadSource,
        contact_date: contactDate,
        first_response_date: firstResponseDate,
        response_type: responseType,
        responder: responder,
        first_response_notes: firstResponseNotes,
        decision: decision,
        demo_date: demoDate,
        demo_notes: demoNotes,
        demo_completion: demoCompletion,
        second_demo_date: secondDemoDate,
        second_demo_notes: secondDemoNotes,
        second_demo_completion: secondDemoCompletion,
        status: status,
      });
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setCompanyName("");
        setCompanyAdministrator("");
        setCompanyAdministratorEmail("");
        setVerifyCompanyAdministratorEmail("");
        setCompanyLocation("");
        setCompanyAdministratorPhone("");
        setCompanySize("");
        setReferredBy("");
        setLeadSourcee("");
        setContactDate("");
        setFirstResponseDate("");
        setResponseType("");
        setResponder("");
        setFirstResponseNotes("");
        setDecision("");
        setDemoDate("");
        setDemoNotes("");
        setDemoCompletion("");
        setSecondDemoDate("");
        setSecondDemoNotes("");
        setSecondDemoCompletion("");
        setStatus("");
        setIsUpdate(false);
      } else {
        toastr.error(result.message);
        setIsUpdate(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsUpdate(false);
    }
  };

  useEffect(() => {
    // Plan list
    const loadCompanySize = async () => {
      try {
        const result = await postData("filter-item/guest-list", {
          sortQuery: { ordering: 1 },
          type: "company-size",
        });
        if (result.data) {
          setSizes(result.data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadCompanySize();
  }, []);

  return (
    <>
      {/* <div className="relative flex justify-between items-center mb-4">
        <div className="text-3xl text-slate-800 font-bold">Lead Tracking</div>
      </div> */}
      <div className="relative bg-white shadow rounded">
        <div className="py-10 px-1">
          <div className="relative space-y-10">
            <Link to={"/"}>
              <div className="h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>
            <div className="mx-auto max-w-4xl space-y-4">
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500 leading-tight inline-flex">
                    {t("company_name")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={companyName}
                    setInput={setCompanyName}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("primary_contact_name")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={companyAdministrator}
                    setInput={setCompanyAdministrator}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("primary_contact_email_address")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={companyAdministratorEmail}
                    setInput={setCompanyAdministratorEmail}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("verify_primary_contact_email_address")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={verifyCompanyAdministratorEmail}
                    setInput={setVerifyCompanyAdministratorEmail}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("company_location")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={companyLocation}
                    setInput={setCompanyLocation}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("primary_contact_phone_number")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={companyAdministratorPhone}
                    setInput={setCompanyAdministratorPhone}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("company_size")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Select
                    xPlacement={"left"}
                    selectedValue={companySize}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t("select_size"), value: "" },
                      ...sizes.map((boardyear_item) => ({
                        _id: boardyear_item?._id,
                        label: boardyear_item?.name,
                        value: boardyear_item?._id,
                      })),
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => setCompanySize(e._id)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("referred_by")} ({t("if_applicable")})
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={referredBy}
                    setInput={setReferredBy}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("lead_source")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Select
                    xPlacement={"left"}
                    selectedValue={leadSource}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t("select_lead_source"), value: "" },
                      { _id: "linkedin", label: "LinkedIn", value: "linkedin" },
                      {
                        _id: "subscriber-referral",
                        label: "Subscriber Referral",
                        value: "subscriber-referral",
                      },
                      { _id: "gartner", label: "Gartner", value: "gartner" },
                      {
                        _id: "google-ads",
                        label: "Google Ads",
                        value: "google-ads",
                      },
                      { _id: "facebook", label: "Facebook", value: "facebook" },
                      {
                        _id: "web-search",
                        label: "Web Search",
                        value: "web-search",
                      },
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => setLeadSourcee(e._id)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("initial_contact_date")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className="w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200"
                    placeholder={t("enter_date")}
                    value={contactDate}
                    options={{
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setContactDate(dateStr);
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("first_response_date")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className="w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200"
                    placeholder={t("enter_date")}
                    value={firstResponseDate}
                    options={{
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setFirstResponseDate(dateStr);
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("response_type")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Select
                    xPlacement={"left"}
                    selectedValue={responseType}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t("select_response_type"), value: "" },
                      { _id: 1, label: t("phone"), value: 1 },
                      { _id: 2, label: t("email"), value: 2 },
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => setResponseType(e._id)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("responder")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Input
                    inputType={"text"}
                    inputValue={responder}
                    setInput={setResponder}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("first_response_notes")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Textarea
                    inputClasses={"!h-32"}
                    inputValue={firstResponseNotes}
                    setTextarea={setFirstResponseNotes}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("decision")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Select
                    xPlacement={"left"}
                    selectedValue={decision}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t("select_decision"), value: "" },
                      { _id: 1, label: t("demo_scheduled"), value: 1 },
                      { _id: 2, label: t("demo_declined"), value: 2 },
                      { _id: 3, label: t("no_response"), value: 3 },
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => setDecision(e._id)}
                  />
                </div>
              </div>
              <div className="inline-flex items-center justify-center w-full">
                <hr className="w-64 h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-gray-900">
                  {t("first_demo")}
                </span>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("date")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className="w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200"
                    placeholder={t("enter_date")}
                    value={demoDate}
                    options={{
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setDemoDate(dateStr);
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("notes")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Textarea
                    inputClasses={"!h-32"}
                    inputValue={demoNotes}
                    setTextarea={setDemoNotes}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("completion")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Select
                    xPlacement={"left"}
                    selectedValue={demoCompletion}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t("select_completion"), value: "" },
                      { _id: 1, label: t("completed"), value: 1 },
                      { _id: 2, label: t("canceled"), value: 2 },
                      { _id: 3, label: t("rescheduled"), value: 3 },
                      { _id: 4, label: t("no_show"), value: 3 },
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => setDemoCompletion(e._id)}
                  />
                </div>
              </div>
              <div className="inline-flex items-center justify-center w-full">
                <hr className="w-64 h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2 dark:text-white dark:bg-gray-900">
                  {t("second_demo")}
                </span>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("date")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Flatpickr
                    ref={flatPicker}
                    className="w-full h-10 rounded bg-slate-50 border border-slate-200 px-3 text-sm text-slate-600 !ring-0 !outline-0 focus:border-gray-400 transition-all duration-200"
                    placeholder={t("enter_date")}
                    value={secondDemoDate}
                    options={{
                      dateFormat: "m/d/Y",
                      //minDate:new Date()
                    }}
                    onChange={(selectedDates, dateStr, instance) => {
                      setSecondDemoDate(dateStr);
                    }}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("notes")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Textarea
                    inputClasses={"!h-32"}
                    inputValue={secondDemoNotes}
                    setTextarea={setSecondDemoNotes}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("completion")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Select
                    xPlacement={"left"}
                    selectedValue={secondDemoCompletion}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t("select_completion"), value: "" },
                      { _id: 1, label: t("completed"), value: 1 },
                      { _id: 2, label: t("canceled"), value: 2 },
                      { _id: 3, label: t("rescheduled"), value: 3 },
                      { _id: 4, label: t("no_show"), value: 3 },
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => setSecondDemoCompletion(e._id)}
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-1 flex items-center justify-start">
                  <div className="text-sm font-medium text-slate-500">
                    {t("status")}
                  </div>
                </div>
                <div className="col-span-2">
                  <Select
                    xPlacement={"left"}
                    selectedValue={status}
                    dropdownClass={"!w-60"}
                    dropdownButtonLabelClass={"!font-bold"}
                    dropdownData={[
                      { _id: "", label: t("select_status"), value: "" },
                      { _id: 1, label: t("sale"), value: 1 },
                      { _id: 2, label: t("no_sale"), value: 2 },
                      { _id: 3, label: t("pending"), value: 3 },
                    ]}
                    dropdownOptionBold={true}
                    getSelectedValue={(e) => setStatus(e._id)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="py-3 px-3 border-t border-slate-200">
          <div className="flex items-center justify-center gap-4">
            <Button
              buttonType={"button"}
              buttonIcon={
                isCancel ? "fa-light fa-spinner fa-spin" : "fa-light fa-times"
              }
              buttonIconPosition={"left"}
              buttonLabel={t("cancel")}
              buttonClasses={
                "!bg-slate-200 !text-slate-600 border border-slate-300"
              }
              functions={onCancel}
              buttonHasLink={false}
              buttonDisabled={isCancel}
            />
            <Button
              buttonType={"button"}
              buttonIcon={
                isUpdate ? "fa-light fa-spinner fa-spin" : "fa-light fa-check"
              }
              buttonIconPosition={"left"}
              buttonLabel={t("save")}
              functions={onUpdate}
              buttonHasLink={false}
              buttonDisabled={isUpdate}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadTracking;
